'use strict';

let processInclude = require('base/util');
require('core/components/spinner');

$(document).ready(function () {
  processInclude(require('./product/detail'));
  processInclude(require('./product/notifyMe'));
  //processInclude(require('core/product/fitguide')); //process include removed here to prevent double API Call on Margiela PDP/Wishlist/Cart
  processInclude(require('core/product/notifyWhenAvailable'));
  processInclude(require('tealium/tealiumEvents'));
  processInclude(require('./tealium/tealiumEvents'));
  // processInclude(require('adobeTarget/loadRecommendations'));
  // processInclude(require('./product/productCarousel'));
});